export const toCamelCase = (s) => s.charAt(0).toLowerCase() + s.slice(1)

export const convertObjectKeysToCamelCase = (obj) => {
    if (Array.isArray(obj)) return obj.map(convertObjectKeysToCamelCase)

    if (obj !== null && typeof obj === "object") {
        return Object.entries(obj).reduce((acc, [k, v]) => {
            const _k = toCamelCase(k)
            acc[_k] = convertObjectKeysToCamelCase(v)
            return acc
        }, {})
    }

    return obj
}

export const buildmetaData = (token, cardId, cardIndex) => ({ token, cardId, cardIndex })
